import PipelineDialog from './EventTypeDialog'

export default PipelineDialog
